import React, { useState, useCallback } from "react";
import { publicClient } from "@/lib/apiClient";

const DEFAULT_STATE = { loading: false, success: false, error: "" };

// Encapsulates lead-form state, validation, and submission.
export function useContactForm({ endpoint = "/leads", initial = {}, source_page = "" } = {}) {
  const baseInitial = React.useMemo(() => ({
    name: "",
    phone: "",
    email: "",
    address: "",
    service: "",
    timeline: "",
    message: "",
    preferred_contact: "",
    website: "", // honeypot
    ...initial,
  }), [initial]);

  const [data, setData] = useState(baseInitial);
  const [state, setState] = useState(DEFAULT_STATE);

  const update = useCallback((key) => (e) => {
    setData((prev) => ({ ...prev, [key]: e.target.value }));
  }, []);

  const reset = useCallback(() => {
    setData(baseInitial);
    setState(DEFAULT_STATE);
  }, [baseInitial]);

  const submit = useCallback(async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    if (!data.name || !data.phone || !data.email) {
      setState({ loading: false, success: false, error: "Please fill in name, phone, and email." });
      return false;
    }
    setState({ loading: true, success: false, error: "" });
    try {
      await publicClient.post(endpoint, { ...data, source_page });
      setState({ loading: false, success: true, error: "" });
      setData(baseInitial);
      return true;
    } catch (err) {
      setState({
        loading: false,
        success: false,
        error: err?.response?.data?.detail || "Something went wrong submitting your request. Please call us or try again.",
      });
      return false;
    }
  }, [data, endpoint, source_page, baseInitial]);

  return { data, update, state, submit, reset };
}
